import PersistedState from 'vuex-persistedstate';
import { SET_TOKEN } from '@/store/modules/auth/mutation-types';
import { EventBus } from '@/event-bus';
import { axiosInstance as gate } from '@/api/axios';

export const AuthCache = new PersistedState({
  key: 'Authentication',
  paths: ['auth.token', 'auth.user'],
  fetchBeforeUse: true,
});

export default function (store) {
  const { token } = store.state.auth;
  if (token) {
    // eslint-disable-next-line dot-notation
    gate.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  store.subscribe((mutation) => {
    switch (mutation.type) {
      case `auth/${SET_TOKEN}`:
        if (mutation.payload) {
          // eslint-disable-next-line dot-notation
          gate.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`;
          EventBus.$emit('authenticated');
        } else {
          // eslint-disable-next-line dot-notation
          gate.defaults.headers.common['Authorization'] = null;
          EventBus.$emit('unauthenticated');
        }
        break;
      default:
    }
  });
}
